<template>
  <div>
    <router-view v-wechat-title="$route.meta.title"></router-view>
    <img :src="url" @click="show = true" />
    <van-image-preview v-model="show" :images="[url]"> </van-image-preview>
  </div>
</template>
<script>
export default {
  data() {
    return {
      url: "",
      show: true,
    };
  },
  mounted() {
    this.url = this.$route.query.url;
  },
};
</script>
<style lang="scss" scoped>
</style>